<template>
  <div :class="[prefixCls + '-confirm']" @keydown.tab.capture="handleTab">
    <i-button
      :class="timeClasses"
      size="small"
      type="text"
      :disabled="timeDisabled"
      v-if="showTime"
      @click="handleToggleTime"
    >
      {{ labels.time }}
    </i-button>

    <DateCompare
      ref="dateCompare"
      v-if="compareDate"
      :compared-range="comparedRange"
      :show-time="showTime"
      :is-compared="isCompared"
      :term="term"
      @on-range-type-change="handleChangeType"
      @on-compare="handleCompare"
    >
    </DateCompare>
    <DateComEnd
      v-if="showLimit"
      ref="DateComEnd"
      @on-com-end="handleComEnd"
      :limit="limit"
    >
    </DateComEnd>

    <i-button
      size="small"
      @click.native="handleClear"
      @keydown.enter.native="handleClear"
    >
      <!-- {{ labels.clear }} -->
      取消
    </i-button>
    <i-button
      size="small"
      type="primary"
      @click.native="handleSuccess"
      @keydown.enter.native="handleSuccess"
    >
      {{ labels.ok }}
    </i-button>
  </div>
</template>
<script>
import iButton from "view-design/src/components/button/button.vue";
import Locale from "view-design/src/mixins/locale";
import Emitter from "view-design/src/mixins/emitter";
import DateCompare from "./date-compare";
import DateComEnd from "./date-com-end.vue";

const prefixCls = "ivu-picker";

export default {
  mixins: [Locale, Emitter],
  components: { iButton, DateCompare, DateComEnd },
  props: {
    showTime: false,
    isTime: false,
    timeDisabled: {
      type: Boolean,
      default: false,
    },
    compareDate: {
      type: Boolean,
      default: false,
    },
    comparedRange: {
      type: Object,
      default: () => ({}),
    },
    isCompared: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Boolean,
    },
    showLimit: {
      type: Boolean,
      default: false,
    },
    term: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      single: false,
      custom: "自定义",
      prefixCls: prefixCls,
    };
  },
  computed: {
    timeClasses() {
      return `${prefixCls}-confirm-time`;
    },
    labels() {
      const labels = ["time", "clear", "ok"];
      const values = [this.isTime ? "selectDate" : "selectTime", "clear", "ok"];
      return labels.reduce((obj, key, i) => {
        obj[key] = this.t("i.datepicker." + values[i]);
        return obj;
      }, {});
    },
  },
  methods: {
    handleCompare(isCompare) {
      this.$emit("on-compare", isCompare);
    },
    handleComEnd(limit) {
      this.$emit("on-com-end", limit);
    },
    handleClear() {
      this.$emit("on-pick-clear");
    },
    handleSuccess() {
      this.$emit("on-pick-success");
    },
    handleToggleTime() {
      if (this.timeDisabled) return;
      this.$emit("on-pick-toggle-time");
      this.dispatch("CalendarPicker", "focus-input");
      this.dispatch("CalendarPicker", "update-popper");
    },
    handleChangeType(type) {
      this.$emit("on-range-type-change", type);
    },
    clearRangeType() {
      this.$refs.dateCompare.clearRangeType();
    },
    handleTab(e) {
      const tabbables = [...this.$el.children];
      const expectedFocus = tabbables[e.shiftKey ? "shift" : "pop"]();

      if (document.activeElement === expectedFocus) {
        e.preventDefault();
        e.stopPropagation();
        this.dispatch("CalendarPicker", "focus-input");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/my-components/custom-date-picker/base/confirm.vue